// NotFound — catch-all /#/404 when the hash route does not match (e.g. Stripe return quirks).
// Kept intentionally minimal: users who paid in the browser should continue in the Chrome extension.

import appIcon from "@/assets/app-icon.png";

export default function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-8 py-12">
      <div className="text-center max-w-xs space-y-6">
        <img src={appIcon} alt="Jobily" className="w-16 h-16 rounded-2xl mx-auto shadow-sm" />
        <p className="font-display text-lg font-medium text-foreground leading-snug">
          Please return to the extension
        </p>
      </div>
    </div>
  );
}
